package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.CREATE_MERCHANT
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

/**
 * Request model for creating a merchant.
 * 
 * According to the updated database schema:
 * - Creates a record in `merchants` table
 * - Creates a record in `company_responsible_persons` table for the signatory
 * 
 * Note: Translation keys for company_name will be created on the server side.
 */
@Serializable
data class CreateMerchantRequestModel(
    // Company details (for merchants table)
    val companyName: String, // maps to merchants.company_name (will create translation key on server)
    val email: String, // maps to merchants.email
    val password: String, // maps to merchants.password
    val dialCode: String, // maps to merchants.dial_code
    val phoneNumber: String, // maps to merchants.phone_number
    val bulstat: String, // maps to merchants.bulstat
    val iban: String, // maps to merchants.iban
    val countryId: Int, // maps to merchants.country_id
    val cityId: Long, // maps to merchants.city_id
    val privacyPolicyAccepted: Boolean, // maps to merchants.privacy_policy_accepted
    val companyStreet: String? = null, // maps to merchants.company_street (nullable)
    val companyImage: ByteArray? = null, // Company logo/image file
    
    // Company signatory details (for company_responsible_persons table) - list of responsible persons
    val signatories: List<com.example.mystybag.sharedmodels.project.requestModels.merchant.SignatoryItem>,
    
    // Verification code (required when creating merchant after email verification)
    val verificationCode: String, // Verification code sent to email

    // SMS verification for company phone (validated on registration step 1B; server must accept same value here)
    val phoneVerificationCode: String,
    
    // Referral code (optional; send empty string for now)
    val referralCode: String = "",
    // Source (optional; send empty string for now)
    val source: String = ""
) : BaseRequestModel(api = CREATE_MERCHANT)
